import color from '@/assets/style/_global.scss';

export const PARTY_GROUPS = [
  ['AfD', 'ABW', 'BMV', 'Freie Wähler/BMV'],
  ['FDP', 'FDP/DVP'],
];

export const SORTED_PARTIES = [
  'NPD',
  'BIW',
  'Freie Wähler/BMV',
  'BMV',
  'ABW',
  'AfD',
  'BVB/FW',
  'FW',
  'Freie Wähler',
  'FDP/DVP',
  'FDP',
  'CSU',
  'CDU/CSU',
  'CDU',
  'SPD',
  'SSW',
  'Die Grünen',
  'Piraten',
  'Die Linke',
  'fraktionslos',
];

export const COLOR = new Map([
  ['NPD', color.polBrown],
  ['BIW', color.polBrown],
  ['Freie Wähler/BMV', color.polBlue],
  ['BMV', color.polBlue],
  ['ABW', color.polBlue],
  ['AfD', color.polBlue],
  ['BVB/FW', color.polOrange],
  ['FW', color.polOrange],
  ['Freie Wähler', color.polOrange],
  ['FDP/DVP', color.polYellow],
  ['FDP', color.polYellow],
  ['CSU', color.polBlack],
  ['CDU/CSU', color.polBlack],
  ['CDU', color.polBlack],
  ['SPD', color.polRed],
  ['SSW', color.polGray],
  ['Die Grünen', color.polGreen],
  ['Piraten', color.polOrange],
  ['Die Linke', color.polPurple],
  ['fraktionslos', color.polGray],
]);

export const LIGHT_COLOR = new Map([
  ['NPD', color.polBrownLight],
  ['BIW', color.polBrownLight],
  ['Freie Wähler/BMV', color.polBlueLight],
  ['BMV', color.polBlueLight],
  ['ABW', color.polBlueLight],
  ['AfD', color.polBlueLight],
  ['BVB/FW', color.polOrangeLight],
  ['FW', color.polOrangeLight],
  ['Freie Wähler', color.polOrangeLight],
  ['FDP/DVP', color.polYellowLight],
  ['FDP', color.polYellowLight],
  ['CSU', color.polBlackLight],
  ['CDU/CSU', color.polBlackLight],
  ['CDU', color.polBlackLight],
  ['SPD', color.polRedLight],
  ['SSW', color.polGrayLight],
  ['Die Grünen', color.polGreenLight],
  ['Piraten', color.polOrangeLight],
  ['Die Linke', color.polPurpleLight],
  ['fraktionslos', color.polGrayLight],
]);

export const LABEL_POSITIONS = new Map([
  ['baden-wurttemberg-16', [
    { party: 'AfD', row: 0 },
    { party: 'FDP/DVP', row: 1 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 0 },
  ]],
  ['baden-wurttemberg-15', [
    { party: 'FDP/DVP', row: 1 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 0 },
  ]],
  ['bayern-17', [
    { party: 'Freie Wähler', row: 1 },
    { party: 'CSU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 0 },
  ]],
  ['brandenburg-6', [
    { party: 'AfD', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['bremen-19', [
    { party: 'FDP', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 0 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['hessen-19', [
    { party: 'FDP', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['mecklenburg-vorpommern-7', [
    { party: 'AfD', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['mecklenburg-vorpommern-6', [
    { party: 'NPD', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['saarland-15', [
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 2 },
    { party: 'Piraten', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['saarland-14', [
    { party: 'FDP', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['sachsen-6', [
    { party: 'AfD', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['sachsen-anhalt-7', [
    { party: 'AfD', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['sachsen-anhalt-6', [
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
  ['schleswig-holstein-19', [
    { party: 'AfD', row: 0 },
    { party: 'FDP', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'SSW', row: 1 },
    { party: 'Die Grünen', row: 0 },
  ]],
  ['schleswig-holstein-18', [
    { party: 'FDP', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'SSW', row: 2 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Piraten', row: 0 },
  ]],
  ['thuringen-6', [
    { party: 'AfD', row: 0 },
    { party: 'CDU', row: 0 },
    { party: 'SPD', row: 0 },
    { party: 'Die Grünen', row: 1 },
    { party: 'Die Linke', row: 0 },
  ]],
]);
